import React from 'react';
import Footer from "../components/Footer";
import LeadToolForm from "../components/LeadToolForm";

const WoningWaarde = ({fallbackBackgroundImage, terms, theme, siteID, footerHtmlText, online_bidding}) => {
    return (
            <>
                <div className="column-full-height">
                    <div
                        style={{
                            position: "fixed",
                            left: 0,
                            top: 0,
                            zIndex: "-1",
                            height: "100%",
                            width: "100%",
                            backgroundSize: "cover",
                            backgroundImage:
                                "url(" +
                                (fallbackBackgroundImage
                                    ? fallbackBackgroundImage.url_md
                                    : "") +
                                ")",
                            backgroundPosition: "center center"
                        }}
                    ></div>
                    <div className="page-header header">
                        <div className="header-content">
                            <h2 className="title">{theme === 'light' && <>Gratis woningwaarde indicatie</>}</h2>
                            <h3 className="subtitle">
                                Gratis woningwaarde indicatie
                            </h3>
                        </div>
                    </div>
                    <LeadToolForm
                        terms={terms}
                        theme={theme}
                        referrer="site"
                        referrerID={siteID}
                        redirect={false}
                    />
                    <Footer
                        footerHtmlText={footerHtmlText}
                        online_bidding={online_bidding}
                    />
                </div>
            </>
        )
}

export default WoningWaarde;
